<ng-container>
    <i class="icon"></i>
</ng-container>

<div class="messages">
    <div *ngIf="heading" class="notification-heading">{{ heading }}</div>
    <ng-content></ng-content>
</div>
